import React from 'react';
import { useNavigate } from 'react-router-dom';
import './index.scss';
import { IMGURL } from 'lib/config';
import IceRight from 'common/img/ic_right.svg';
import BuyBtn from '../BuyBtn';
import LazyImg from 'common/components/LazyImg';
import { ILink } from 'lib/types';
type ProductItemProps = {
  prokind: any;
};
const ProductItem: React.FC<ProductItemProps> = ({ prokind }) => {
  const navigate = useNavigate();
  const goOut = (link: ILink, display: any) => {
    var path = link.type === 'redirect' ? link.link : `${IMGURL}${link.link}`;
    if (display.id === '9903') {
      navigate(`/bxsc/xyx/${display.id}?link=${link.link}`);
    } else {
      window.open(path, '_blank');
    }
  };
  return (
    <>
      <div className='product_item'>
        {prokind.map((item: any, index: number) => (
          <div className='list_left' key={index}>
            <div className='left_img'>
              <LazyImg src={`${IMGURL}${item.display.icon}`} alt='' />
            </div>
            <div className='list_mesg'>
              <div className='list_bigTitle'>{item.display.name}</div>
              <div className='list_desc'>
                {item.display.feature && (
                  <div className='desc_item'>
                    <div className='desc_img'>
                      <img src={IceRight} alt='' />
                    </div>
                    <div>{item.display.feature}</div>
                  </div>
                )}

                {item.display.feature1 && (
                  <div className='desc_item'>
                    <div className='desc_img'>
                      <img src={IceRight} alt='' />
                    </div>
                    <div>{item.display.feature1}</div>
                  </div>
                )}

                {item.display.feature2 && (
                  <div className='desc_item'>
                    <div className='desc_img'>
                      <img src={IceRight} alt='' />
                    </div>
                    <div>{item.display.feature2}</div>
                  </div>
                )}

                {item.display.productionDescription && (
                  <div className='desc_item ellipsis'>
                    {item.display.productionDescription}
                  </div>
                )}
              </div>

              {/* 产品-展示二维码 */}
              {(item.link.type === 'product' || item.link.type === 'out') && (
                <div className='list_do'>
                  <div className='list_price flex-end'>
                    <div> {item.display.premium}</div>
                    <div className='price_start'>{item.display.premium2}</div>
                  </div>
                  <BuyBtn link={item.link} />
                </div>
              )}

              {/* 外链-跳转外链或pdf文件 */}
              {(item.link.type === 'attach' ||
                item.link.type === 'redirect') && (
                <div className='list_do_2'>
                  <div
                    className='buy_btn_wrap flex-center hander noselect'
                    onClick={() => goOut(item.link, item.display)}
                  >
                    <p className='title'>查看更多</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
export default ProductItem;
